import { Question } from './question.js';

export class ShortTextQuestion extends Question {
    constructor(question, ctx) {
        super(question, ctx);
        this.answer = [''];
    }

    renderContent() {
        let textBox = document.createElement('div');
        textBox.style.marginTop = '16px';
        textBox.style.position = 'relative';

        let text = document.createElement('textarea');
        text.placeholder = this.question.placeHolder;
        text.setAttribute('aria-labelledby', 'ph-title-' + this.question.id);
        this.textInput = text;
        text.maxLength = this.question.answerMaxLength;
        text.style.minHeight = '55px';
        text.style.maxHeight = '370px';
        text.style.overflowY = 'auto';
        text.style.resize = 'none';
        textBox.appendChild(text);

        text.addEventListener('focus', () => {
            setTimeout(() => text.scrollIntoView({ block: 'center' }), 300);
        });

        let lengthHint = document.createElement('div');
        lengthHint.classList.add('ph-length-hint');
        lengthHint.id = 'lengthHint-' + this.question.id;
        lengthHint.setAttribute('aria-live', 'polite');
        lengthHint.textContent = `${text.value.length}/${this.question.answerMaxLength}`;
        text.setAttribute('aria-describedby', 'lengthHint-' + this.question.id);
        textBox.appendChild(lengthHint);

        text.addEventListener('input', () => {
            lengthHint.textContent = text.value.length + `/${this.question.answerMaxLength}`;
            this.answer[0] = text.value;
            this.ctx.updateAnswers(this.question, this.answer);
        });

        return textBox;
    }

    renderNextButton() {
        let nextButton = document.createElement('button');
        nextButton.classList.add('ph-btn--primary');
        nextButton.textContent = this.question.buttonName;
        nextButton.addEventListener('click', () => {
            if (this.answer[0] === '' && this.question.isObligated) {
                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                errorElement.classList.add('ph-error');
                errorElement.textContent = this.question.errorText;
                this.setAriaInvalid(this.textInput);
            } else {
                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                errorElement.classList.remove('ph-error');
                errorElement.textContent = '';
                this.clearAriaInvalid(this.textInput);

                this.ctx.goNext(this.question, this.answer[0]);
            }
        });
        return nextButton;
    }
}
